mutation UpdateUserPassword($newPassword: String!) {
  updateUserPassword(newPassword: $newPassword) {
    ok
    errors
  }
}
